import React, { useEffect, useState } from "react";
 import MetaTags from "react-meta-tags";
import {
    Container,
    Row,
} from "reactstrap";
import BuildingForm from "../BuildingForm"
import CompoundService from "services/Admin/CompoundService"
import { SuccessCreated ,SuccessOk} from "configs/statusCode";
import { adminPrefix } from "configs/routePrefix";

const EditBuilding = (props) => {
 const id=props.match.params.id
    return (
        <>
            <div className='page-content'>
                <MetaTags>
                    <title>Building</title>
                </MetaTags>
                <Container fluid>
                    <Row>
                    <h4><button
                                className="p-0 m-0 border-0 bg-light"
                                onClick={() => {
                                    props.history.push(`${adminPrefix}/Admin-developer/building`)
                                }}>
                                {/* <i className="fa fa-arrow-left text-primary me-2"></i> */}
                            </button>Edit Building</h4>
                    </Row>
                  <BuildingForm id={id} history={props.history} />
                </Container>
            </div>
        </>
    )
}

export default EditBuilding